exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-box[data-v-d6f4bb3c]{font-size:13px;font-family:PingFangSC-Regular, PingFang SC;font-weight:400;color:#303133}.card-box .box-card .setting-container .card-list .info[data-v-d6f4bb3c]{font-size:12px;color:#909399;margin-left:8px}[data-v-d6f4bb3c] .el-card.is-always-shadow{border:none}[data-v-d6f4bb3c] .el-select{width:85%}[data-v-d6f4bb3c] .el-input--medium .el-input__inner{font-size:13px}\n", ""]);

// exports
